module.exports = __webpack_public_path__ + "img/a9_12.f74ae431.jpg";